import React from "react";
import "./Martini.css";

function Martini(props) {
	return (
		<svg
			version="1.1"
			xmlns="http://www.w3.org/2000/svg"
			x="0px"
			y="0px"
			viewBox="0 0 1000 1000"
			enableBackground="new 0 0 1000 1000"
			xmlSpace="preserve"
		>
			<metadata>
				Svg Vector Icons : http://www.onlinewebfonts.com/icon{" "}
			</metadata>
			<g>
				<path
					className="martini-glass"
					d="M691.8,269.1C691.8,269,691.8,269,691.8,269.1l88.6-88.6c4.7-4.7,4.7-12.4,0-17.1c-4.7-4.7-12.4-4.7-17.1,0l-85,85H172l-85-85c-4.7-4.7-12.4-4.7-17.1,0c-4.7,4.7-4.7,12.4,0,17.1l88.5,88.5c0,0,0,0,0,0L413,523.6v442.2H310.8c-6.7,0-12.1,5.4-12.1,12.1c0,6.7,5.4,12.1,12.1,12.1h234.6c6.7,0,12.1-5.4,12.1-12.1c0-6.7-5.4-12.1-12.1-12.1H437.2V523.6L691.8,269.1z M654,272.6L425.1,501.5L196.2,272.6H654z"
				/>
				<path d="M771.8,10c-89.3,0-161.9,72.6-161.9,161.9c0,15.4,2.2,30.6,6.4,45.3c1.9,6.4,8.6,10.1,15,8.3c6.4-1.9,10.1-8.6,8.2-15c-3.6-12.4-5.5-25.4-5.5-38.5c0-75.9,61.8-137.7,137.7-137.7c75.9,0,137.7,61.8,137.7,137.7c0,75.9-61.8,137.7-137.7,137.7c-2.1,0-4.3,0-6.4-0.1c-5.9,0.4-12.3,4.9-12.6,11.6c-0.3,6.7,4.9,12.3,11.6,12.6c2.4,0.1,4.9,0.1,7.4,0.1c89.3,0,161.9-72.6,161.9-161.9C933.7,82.6,861.1,10,771.8,10z" />
			</g>
		</svg>
	);
} //Martini

export default Martini;
